export default __webpack_public_path__ + "static/media/ShortlistOutline.9d7432b4.svg";